(() => {
  if (window.__culldSignup) return;
  window.__culldSignup = true;

  const KEY = 'culld_signed_up';
  const SEEN = 'culld_pop_seen';
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  const done = (scope) => {
    scope.classList.add('is-done');
    store.set(KEY, '1');
  };

  // Native submit so Shopify's bot protection can attach its token. The page reloads with
  // ?customer_posted=true#<form id> and the success state is shown below.
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-culld-signup]');
    if (!form) return;
    const email = form.querySelector('input[type="email"]');
    const btn = form.querySelector('button[type="submit"]');
    const err = form.querySelector('.cs-err');
    err.textContent = '';
    if (!email.value.trim() || !email.checkValidity()) {
      e.preventDefault();
      err.textContent = "That doesn't look like an email. Try again.";
      email.focus();
      return;
    }
    const label = btn.textContent;
    btn.textContent = 'Sending\u2026';
    // If a bot check pops up and gets closed, don't leave the button stuck
    setTimeout(() => { btn.textContent = label; }, 12000);
  });

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-cs-copy]');
    if (!b) return;
    try { await navigator.clipboard.writeText(b.dataset.csCopy); b.textContent = 'Copied'; }
    catch (x) { b.textContent = 'Select it'; }
    setTimeout(() => { b.textContent = 'Copy'; }, 2000);
  });

  const posted = location.search.includes('customer_posted=true');
  const pop = document.querySelector('[data-culld-pop]');
  if (posted) {
    document.querySelectorAll('[data-cs]').forEach(done);
    if (pop && location.hash === '#CulldPopForm') {
      pop.addEventListener('click', (e) => {
        if (e.target === pop || e.target.closest('[data-cs-close]')) pop.close();
      });
      pop.showModal();
      return;
    }
    const band = document.getElementById('cull-list');
    if (band) setTimeout(() => band.scrollIntoView({ block: 'center' }), 300);
    return;
  }
  if (!pop) return;

  pop.addEventListener('click', (e) => {
    if (e.target === pop || e.target.closest('[data-cs-close]')) pop.close();
  });

  if (pop.hasAttribute('data-preview')) { pop.showModal(); return; }

  const days = Number(pop.dataset.days) || 14;
  const delay = (Number(pop.dataset.delay) || 10) * 1000;
  const last = Number(store.get(SEEN)) || 0;
  if (store.get(KEY) || pop.dataset.customer === '1' || Date.now() - last < days * 864e5) return;

  let timer;
  // Horizon scrolls .page-wrapper on desktop, the window on mobile, so listen in capture
  const onScroll = (e) => {
    const el = e.target === document ? document.scrollingElement : e.target;
    if (!el || !el.scrollHeight) return;
    const h = el.scrollHeight, v = el.clientHeight;
    if (h > v * 1.5 && (el.scrollTop + v) / h > 0.5) open();
  };
  const onOut = (e) => { if (!e.relatedTarget && e.clientY <= 0) open(); };
  const cleanup = () => {
    clearTimeout(timer);
    document.removeEventListener('scroll', onScroll, true);
    document.removeEventListener('mouseout', onOut);
  };
  function open() {
    cleanup();
    if (pop.open || document.querySelector('dialog[open]:not([data-culld-pop])')) return;
    store.set(SEEN, String(Date.now()));
    pop.showModal();
  }
  timer = setTimeout(open, delay);
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  if (matchMedia('(hover: hover)').matches) document.addEventListener('mouseout', onOut);
})();
